/* eslint-disable no-shadow */
const memoize = require('@emotion/memoize').default;
const isPropValid = require('@emotion/is-prop-valid').default;

const {
    compose,
    space,
    typography,
    color,
    layout,
    flexbox,
    border,
    background,
    position,
    shadow,
    buttonStyle,
    textStyle,
    colorStyle
} = require('styled-system');
const grid = require('style/grid');

const all = compose(space, typography, color, layout, flexbox, border, background, position, grid, shadow, buttonStyle, textStyle, colorStyle);

const props = all.propNames;

const createShouldForwardProp = props => {
    const regex = new RegExp(`^(${props.join('|')})$`);

    return memoize(prop => prop === '__ref' || (isPropValid(prop) && !regex.test(prop)));
};

module.exports = createShouldForwardProp(props);
